import { Button, Popover, Progress, Tag } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../assets/colors/dark';
import IconSettings from '../../assets/icons/settings.svg';
import { EditIcon } from '../../icons/Edit';
import { Copy } from '../../components/Copy';
import { StateTag } from '../../components/StateTag';
import { BiDetail } from 'react-icons/bi';

const progressColors = (percent) =>
  percent > 80
    ? colorsDark.$online
    : percent > 60
    ? colorsDark.$warning
    : colorsDark.$errors;

export const CameraSettingPopup = ({
  camera,
  isVisible,
  setVisibleDetail,
  owner,
  handleUpdateStream,
  onClickEditButton,
  onClickDeleteButton,
  onClickServiceDetail,
  onClickHistoryEvent,
  children,
  allowRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Popover
      trigger="click"
      visible={isVisible}
      onVisibleChange={(visible) =>
        visible ? setVisibleDetail(camera.serial) : setVisibleDetail(null)
      }
      key={camera.serial}
      placement="rightTop"
      content={
        <div className="popover-camera-setting">
          <div className="detail status">
            <div className="title">{t('State')}:</div>
            <div className="content">
              <StateTag state={camera.state} />
            </div>
          </div>
          <div className="detail">
            <div className="title">{t('Address')}:</div>
            <div className="content">{camera.note}</div>
          </div>
          <div className="detail">
            <div className="title">{t('Active at')}:</div>
            <div className="content">{camera.createdAt}</div>
          </div>
          <div className="detail">
            <div className="title">{t('Permission')}:</div>
            <div className="content">
              {t(camera.ownerId === owner ? 'Owner' : 'Viewer')}
            </div>
          </div>
          <div className="detail">
            <div className="title">{t('Strength')}:</div>
            <div className="content">
              <Progress
                percent={camera.strength}
                steps={5}
                strokeColor={progressColors(camera.strength)}
                format={(percent) => `${percent}%`}
              />
            </div>
          </div>
          <div className="detail">
            <div className="title">{t('Stream')}:</div>
            <div className="content" title={camera.source} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {camera.source && camera.source.length > 15
                ? camera.source.slice(0, 15) + '..'
                : camera.source}
              <span
                className="change_source hover-popup"
                style={{ color: '#0e9347', display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 4 , width : '15px' , height : '17px' }}
                onClick={() => {
                  setVisibleDetail(null);
                  handleUpdateStream(camera);
                }}
              >
                <EditIcon style={{ fontSize: 20 }} />
              </span>
              <Copy content={camera.source} />
            </div>
          </div>
          <div className="detail">
            <div className="title">{t('History event')}:</div>
            <div
              className="title hover-popup"
              style={{ color: '#0e9347', cursor: 'pointer' }}
              onClick={onClickHistoryEvent}
            >
              <BiDetail color="#0e9347" size={20} />
            </div>
          </div>
          <div className="detail">
            <div className="title">{t('Services')}:</div>
            <div
              className="title hover-popup"
              style={{ color: '#0e9347', cursor: 'pointer' }}
              onClick={onClickServiceDetail}
            >
              <BiDetail color="#0e9347" size={20} />
            </div>
          </div>
          <div className="button-side">
            {allowRemove && (
              <Button
                className="delete"
                style={{
                  color: colorsDark.$errors,
                  borderColor: colorsDark.$errors,
                }}
                onClick={onClickDeleteButton}
              >
                {t('Delete')}
              </Button>
            )}
            <Button onClick={onClickEditButton}>{t('Edit')}</Button>
          </div>
        </div>
      }
      title={<div className="title-item">{camera.name}</div>}
    >
      {children || (
        <div className="edit">
          <img src={IconSettings} alt="camera" className="icon" />
        </div>
      )}
    </Popover>
  );
};

export default CameraSettingPopup;
